module.exports = __webpack_public_path__ + "img/escola_creative_learning_ensinobilingue.7bd74e37.jpeg";